import './css/index.css';
import { array, bool, number } from 'prop-types';
import React from 'react';

const Legend = ( { yValues, alt, legendLabels, altLegendLabels, width } ) => {

    return (

        <div className="legend-chart">
            <div className="legend-section-permanent">
                {
                    yValues[ 0 ] && yValues[ 0 ].filter( v => ( v.name !== null ) ).map( ( v, i, all ) => {

                        return (

                            <div className="legend-item" key={ i }>

                                <div className="legend-color" style={ { backgroundColor: v.color } }></div>

                                { alt
                                    ? <div className="legend-text">{ altLegendLabels[ i ] }</div>
                                    : <div className="legend-text">{ legendLabels[ i ] }</div>}

                            </div>

                        );

                    } )
                }

            </div>

        </div>

    );

};

Legend.propTypes = {
    yValues: array,
    alt: bool,
    legendLabels: array,
    altLegendLabels: array,
    width: number,
};

export default Legend;
